"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var baseOption = {
  root: null,
  threshold: 0.5,
  rootMargin: '0px'
};
/**
 * Intersection Observer를 hook으로 분리하여 intersect 되었을 시에 callback(onIntersect)을 호출합니다.
 *
 * @export
 * @param {() => void} onIntersect
 * @param {OptionProps} [option]
 * @returns {(Dispatch<SetStateAction<HTMLElement | null>>)}
 */

/* Example
function Component() {
  function intersectionCallback(): void {
    // do something..
  }

  const setIntersectionRef = useIntersection(intersectionCallback, {
    root: null,
    threshold: 0.5,
    rootMargin: '0% 0% 33% 0%',
  });
}
*/

function useIntersect(onIntersect, option) {
  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      ref = _react_1$useState2[0],
      setRef = _react_1$useState2[1];

  var checkIntersect = react_1.useCallback(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];

    if (entry.isIntersecting) {
      onIntersect();
    }
  }, [onIntersect]);
  react_1.useEffect(function () {
    var observer;

    if (ref) {
      observer = new IntersectionObserver(checkIntersect, Object.assign(Object.assign({}, baseOption), option));
      observer.observe(ref);
    }

    return function () {
      return observer && observer.disconnect();
    };
  }, [ref, option, checkIntersect]);
  return setRef;
}

exports.default = useIntersect;